/**
 * Clears the cart right after a successful login or logout.
 *
 * Primary detection: compare the previous page’s auth state (sessionStorage) to
 * the current Liquid-rendered state (`window.themeCustomerLoggedIn`). Same-tab
 * flows are reliable without Referer.
 *
 * Fallback: if `document.referrer` matches `routes.account_login_url` or
 * `account_logout_url` (helps new tabs where sessionStorage has no prior state).
 *
 * Uses Shopify Ajax Cart API: POST /cart/clear.js
 */
(function () {
  var STORAGE_KEY = 'aero_last_auth_state';

  function pathMatchesRoute(referrer, routeHref) {
    if (!referrer || !routeHref) return false;
    try {
      var ref = new URL(referrer);
      var route = new URL(routeHref, window.location.origin);
      return ref.pathname === route.pathname;
    } catch {
      return false;
    }
  }

  /**
   * Updates `#cart-icon-bubble` immediately. `publish(cart-update)` alone is not enough:
   * `cart.js` only listens when `<cart-items>` is on the page, so the header bubble
   * would stay stale until the next full page load.
   * Matches patterns in `aero-shop-b2b.liquid` / `aero-main-product.liquid`.
   */
  function updateHeaderCartIcon(cartData) {
    var cartLink = document.getElementById('cart-icon-bubble');
    if (!cartLink) return;

    var count =
      cartData && typeof cartData.item_count === 'number' ? cartData.item_count : 0;

    // Airways DS count badge: a single .air-badge--count span whose text is the
    // count (empty -> auto-hides via .air-badge--count:empty), plus a sibling
    // screen-reader span.
    var badge = cartLink.querySelector('.air-badge--count');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'air-badge air-badge--count';
      badge.setAttribute('aria-hidden', 'true');
      cartLink.appendChild(badge);
    }
    badge.textContent = count === 0 ? '' : String(count);

    // sections/aero-header.liquid renders the SR count as .air-sr-only. This
    // looked for .visually-hidden, which the header never emits, so it always
    // appended a second span instead of updating the existing one.
    var srCount = cartLink.querySelector('.air-sr-only');
    if (count === 0) {
      if (srCount) srCount.remove();
    } else {
      if (!srCount) {
        srCount = document.createElement('span');
        srCount.className = 'air-sr-only';
        cartLink.appendChild(srCount);
      }
      srCount.textContent = count + (count === 1 ? ' item in cart' : ' items in cart');
    }
  }

  function clearCartAndNotify() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function () {
        return fetch('/cart.js', { credentials: 'same-origin' });
      })
      .then(function (r) {
        return r.json();
      })
      .then(function (cartData) {
        updateHeaderCartIcon(cartData);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'aero-auth-cart-clear', cartData });
        }
      })
      .catch(function () {});
  }

  function run() {
    var loginUrl = window.routes && window.routes.account_login_url;
    var logoutUrl = window.routes && window.routes.account_logout_url;

    var current = window.themeCustomerLoggedIn === true ? 'customer' : 'guest';
    var prev = sessionStorage.getItem(STORAGE_KEY);

    var shouldClear = false;

    if (prev === 'guest' && current === 'customer') {
      shouldClear = true;
    } else if (prev === 'customer' && current === 'guest') {
      shouldClear = true;
    } else if (loginUrl && logoutUrl) {
      var ref = document.referrer;
      if (ref) {
        if (current === 'customer' && pathMatchesRoute(ref, loginUrl)) {
          shouldClear = true;
        }
        if (current === 'guest' && pathMatchesRoute(ref, logoutUrl)) {
          shouldClear = true;
        }
      }
    }

    sessionStorage.setItem(STORAGE_KEY, current);

    if (shouldClear) {
      clearCartAndNotify();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
